import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "play-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", fillOpacity: 0.15, fillRule: "evenodd", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.5, d: "M3.75 12.75 12.25 8l-8.5-4.75z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
